function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Api from "../ajax/OrganizationApi";
import * as OrganizationModalComponent from "./OrganizationModalComponent";
import * as OrganizationSupportModalComponent from "./OrganizationSupportModalComponent";
import { NullNumberToBlank } from "../commons/Utility";
import { ApiResultCodes } from "../enum/ApiResultCodes";
import IntlMessage from '../commons/Intl';
import { Label, Organizations, OrganizationStatus, Placeholder, Services } from '../commons/IntlMessages';
import { OrganizationStatusTypes } from "../enum/OrganizationStatusTypes";
import moment from 'moment';
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language);
/**
 * メインコンポーネント
 */

var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);
    _this.state = {
      Selected: null,
      CurrentUserAuthorityId: 0,
      OrganizationList: [],
      OrganizationModalMode: OrganizationModalComponent.Mode.None,
      OrganizationSupportModalMode: OrganizationSupportModalComponent.Mode.None,
      SearchText: "",
      CurrentPage: 1,
      DataCount: 0
    };

    _this.GetList(_this.state.CurrentPage);

    return _this;
  }
  /**
   * 対象の検索テキストを更新します。
   *
   * @param e イベント
   */


  _createClass(MainComponent, [{
    key: "updateSearchText",
    value: function updateSearchText(e) {
      this.setState({
        SearchText: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * リスト表示
     */

  }, {
    key: "GetList",
    value: function GetList(pageNum) {
      var _this2 = this;

      Api.Query(this.state.SearchText, (pageNum - 1) * this.props.pageSize + 1, this.props.pageSize, function (data) {
        _this2.setState({
          Selected: null,
          CurrentUserAuthorityId: data.CurrentUserAuthorityId,
          OrganizationList: data.OrganizationList,
          DataCount: data.Count
        });
      });
    }
    /**
     * 前ページ表示
     */

  }, {
    key: "previousPage",
    value: function previousPage() {
      var page = 0;

      if (this.state.CurrentPage <= 1) {
        page = 1;
      } else {
        page = this.state.CurrentPage - 1;
      }

      this.setState({
        CurrentPage: page
      });
      this.GetList(page);
    }
    /**
     * 次ページ表示
     */

  }, {
    key: "nextPage",
    value: function nextPage() {
      var page = 0;
      var maxPage = Math.ceil(this.state.DataCount / this.props.pageSize);

      if (maxPage == 0) {
        page = 1;
      } else if (this.state.CurrentPage >= maxPage) {
        page = maxPage;
      } else {
        page = this.state.CurrentPage + 1;
      }

      this.setState({
        CurrentPage: page
      });
      this.GetList(page);
    }
    /**
     * 組織モーダルを追加で起動します。
     */

  }, {
    key: "openAddOrganizationModal",
    value: function openAddOrganizationModal() {
      this.setState({
        OrganizationModalMode: OrganizationModalComponent.Mode.Add
      });
    }
    /**
     * 組織モーダルを編集で起動します。
     */

  }, {
    key: "openModifyOrganizationModal",
    value: function openModifyOrganizationModal(m) {
      if (this.state.CurrentUserAuthorityId == 1) {
        this.setState({
          OrganizationModalMode: OrganizationModalComponent.Mode.Modify,
          Selected: {
            OrganizationId: m.OrganizationId,
            OrganizationName: m.OrganizationName,
            ActualExtentionFlg: m.ActualExtentionFlg,
            OrganizationStatus: m.OrganizationStatus,
            Domain: m.Domain,
            UseWhiteroom: m.UseWhiteroom,
            UseEverywhere: m.UseEverywhere,
            UseOneDrive: m.UseOneDrive,
            ClientId: m.ClientId,
            ContractList: m.ContractList,
            Deleted: m.Deleted,
            UpdateDateTime: m.UpdateDateTime
          }
        });
      } else {
        this.setState({
          OrganizationSupportModalMode: OrganizationSupportModalComponent.Mode.Support,
          Selected: {
            OrganizationId: m.OrganizationId,
            OrganizationName: m.OrganizationName,
            ActualExtentionFlg: m.ActualExtentionFlg,
            OrganizationStatus: m.OrganizationStatus,
            Domain: m.Domain,
            UseWhiteroom: m.UseWhiteroom,
            UseEverywhere: m.UseEverywhere,
            UseOneDrive: m.UseOneDrive,
            ClientId: m.ClientId,
            ContractList: m.ContractList,
            Deleted: m.Deleted,
            UpdateDateTime: m.UpdateDateTime
          }
        });
      }
    }
    /**
     * 組織を切り替えます。
     */

  }, {
    key: "changeOrganization",
    value: function changeOrganization(m) {
      var _this3 = this;

      this.setState({
        OrganizationModalMode: OrganizationModalComponent.Mode.None,
        Selected: {
          OrganizationId: m.OrganizationId,
          OrganizationName: m.OrganizationName,
          ActualExtentionFlg: m.ActualExtentionFlg,
          OrganizationStatus: m.OrganizationStatus,
          Domain: m.Domain,
          UseWhiteroom: m.UseWhiteroom,
          UseEverywhere: m.UseEverywhere,
          UseOneDrive: m.UseOneDrive,
          ClientId: m.ClientId,
          ContractList: m.ContractList,
          Deleted: m.Deleted,
          UpdateDateTime: m.UpdateDateTime
        }
      });
      Api.ChangeOrganization(m.OrganizationId, m.OrganizationName, m.UseWhiteroom, m.UseEverywhere, m.ActualExtentionFlg, function (data) {
        _this3.setState({
          Selected: null
        });

        if (data.ResultCode == ApiResultCodes.Success) {
          window.location.reload();
        }
      });
    }
    /**
     * 組織を検索します。
     *
     * @param searchText 検索文字列
     */

  }, {
    key: "searchOrganization",
    value: function searchOrganization() {
      var page = 1;
      this.setState({
        CurrentPage: page
      });
      this.GetList(page);
    }
    /**
     * 組織を登録します。
     *
     * @param organizationName 組織名
     * @param domain ドメイン
     * @param useEverywhere EVERYWHERE利用
     * @param useOneDrive OneDriveを使用可能かどうか
     * @param clientId クライアントID
     * @param entryContract 登録する契約
     */

  }, {
    key: "entryOrganizationModal",
    value: function entryOrganizationModal(organizationName, domain, useEverywhere, useOneDrive, clientId, entryContract) {
      var _this4 = this;

      Api.AddOrganization(organizationName, domain, useEverywhere, useOneDrive, clientId, entryContract, function (data) {
        _this4.setState({
          Selected: null
        });

        if (data.ResultCode == ApiResultCodes.Success) {
          _this4.GetList(_this4.state.CurrentPage);
        }
      });
    }
    /**
     * 組織を更新します。
     *
     * @param organizationId 組織ＩＤ
     * @param organizationName 組織名
     * @param domain ドメイン
     * @param useEverywhere EVERYWHERE利用
     * @param useOneDrive OneDriveを使用可能かどうか
     * @param clientId クライアントID
     * @param entryContract 登録する契約
     * @param modifyContractList 編集した契約リスト
     * @param removeContractIdList
     * @param updateDateTime 更新日時
     * @param fn ファンクション
     */

  }, {
    key: "modifyOrganizationModal",
    value: function modifyOrganizationModal(organizationId, organizationName, domain, useEverywhere, useOneDrive, clientId, entryContract, modifyContractList, removeContractIdList, updateDateTime) {
      var _this5 = this;

      Api.ModifyOrganization(organizationId, organizationName, domain, useEverywhere, useOneDrive, clientId, entryContract, modifyContractList, removeContractIdList, updateDateTime, function (data) {
        _this5.setState({
          Selected: null
        });

        if (data.ResultCode == ApiResultCodes.Success) {
          _this5.GetList(_this5.state.CurrentPage);
        }
      });
    }
    /**
     * 組織を削除します。
     *
     * @param organizationId 組織ＩＤ
     * @param organizationName 組織名
     * @param updateDateTime 更新日時
     */

  }, {
    key: "deleteOrganizationModal",
    value: function deleteOrganizationModal(organizationId, organizationName, updateDateTime) {
      var _this6 = this;

      Api.DeleteOrganization(organizationId, organizationName, updateDateTime, function (data) {
        _this6.setState({
          Selected: null
        });

        if (data.ResultCode == ApiResultCodes.Success) {
          _this6.GetList(_this6.state.CurrentPage);
        }
      });
    }
    /**
     * 組織のサービス状態を変更します。
     *
     * @param organizationId 組織ＩＤ
     * @param organizationName 組織名
     * @param deleted 削除フラグ
     * @param updateDateTime 更新日時
     */

  }, {
    key: "changeServiceStatus",
    value: function changeServiceStatus(organizationId, organizationName, deleted, updateDateTime) {
      var _this7 = this;

      Api.ChangeServiceStatus(organizationId, organizationName, deleted, updateDateTime, function (data) {
        _this7.setState({
          Selected: null
        });

        if (data.ResultCode == ApiResultCodes.Success) {
          _this7.GetList(_this7.state.CurrentPage);
        }
      });
    }
    /**
     * 組織モーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenOrganizationModal",
    value: function hiddenOrganizationModal() {
      this.setState({
        OrganizationModalMode: OrganizationModalComponent.Mode.None
      });
    }
    /**
     * 組織の現在の拡張フラグを変更します。
     *
     * @param organizationId 組織ＩＤ
     * @param extentionFlg 拡張フラグ
     * @param updateDateTime 更新日時
     */

  }, {
    key: "changeActualExtentionFlg",
    value: function changeActualExtentionFlg(organizationId, extentionFlg, updateDateTime) {
      var _this8 = this;

      Api.ChangeActualExtentionFlg(organizationId, extentionFlg, updateDateTime, function (data) {
        _this8.setState({
          Selected: null
        });

        if (data.ResultCode == ApiResultCodes.Success) {
          _this8.GetList(_this8.state.CurrentPage);
        }
      });
    }
    /**
     * 組織サポートモーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenOrganizationSupportModal",
    value: function hiddenOrganizationSupportModal() {
      this.setState({
        OrganizationSupportModalMode: OrganizationSupportModalComponent.Mode.None
      });
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.common.bind();
    }
    /**
     * ComponentがDOMツリーから削除された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
    /**
     * サービス種別表示名を戻します。
     *
     * @param serviceType サービス種別
     */

  }, {
    key: "getServiceTypeDisplayName",
    value: function getServiceTypeDisplayName(serviceType) {
      switch (serviceType) {
        case 0:
          return intl.format(Services.Enterprise);

        case 1:
          return intl.format(Services.Starter);

        default:
          return "";
      }
    }
    /**
     * サービス種別表示名を戻します。
     *
     * @param serviceType サービス種別
     */

  }, {
    key: "getUseEverywhereDisplayName",
    value: function getUseEverywhereDisplayName(useEverywhere) {
      if (useEverywhere) {
        return intl.format(Label.UseEverywhere);
      } else {
        return "";
      }
    }
    /**
     * 組織状態表示名を戻します。
     *
     * @param status 状態
     */

  }, {
    key: "getOrganizationStatusDisplayName",
    value: function getOrganizationStatusDisplayName(status) {
      switch (status) {
        case OrganizationStatusTypes.UnderContract:
          return intl.format(OrganizationStatus.UnderContract);

        case OrganizationStatusTypes.Deleted:
          return intl.format(OrganizationStatus.Deleted);

        case OrganizationStatusTypes.Suspended:
          return intl.format(OrganizationStatus.Suspended);

        case OrganizationStatusTypes.NoContract:
          return intl.format(OrganizationStatus.NoContract);

        case OrganizationStatusTypes.Trial:
          return intl.format(OrganizationStatus.Trial);

        case OrganizationStatusTypes.ScheduleContract:
          return intl.format(OrganizationStatus.ScheduleContract);

        default:
          return "";
      }
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this9 = this;

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-10 offset-1 col-lg-8 offset-lg-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "title"
      }, /*#__PURE__*/React.createElement("img", {
        width: "60",
        height: "60",
        src: "/assets/img/organization_icon.svg"
      }), /*#__PURE__*/React.createElement("h2", null, intl.format(Organizations.Title)))), /*#__PURE__*/React.createElement("div", {
        className: "col-3"
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-10 offset-1 col-lg-8 offset-lg-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 select-wrap-top"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-4"
      }, /*#__PURE__*/React.createElement("input", {
        name: "search",
        type: "text",
        className: "form-control-search",
        maxLength: 50,
        onChange: function onChange(e) {
          return _this9.updateSearchText(e);
        },
        value: this.state.SearchText,
        tabIndex: 101,
        placeholder: intl.format(Placeholder.SearchWord)
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-6 search-btn"
      }, /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.searchOrganization.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Search"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "36",
        height: "36",
        src: "/assets/img/search_icon.svg"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-1 text-right"
      }, this.state.CurrentUserAuthorityId == 1 && /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.openAddOrganizationModal.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Add organization"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "36",
        height: "36",
        src: "/assets/img/add_icon.svg"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-1 text-right paging-btn"
      }, this.state.CurrentPage <= 1 && /*#__PURE__*/React.createElement("a", {
        className: "button disabled",
        href: "#",
        title: "Previous"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_left.svg"
      })), this.state.CurrentPage > 1 && /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.previousPage.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Previous"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_left.svg"
      })), this.state.CurrentPage >= Math.ceil(this.state.DataCount / this.props.pageSize) && /*#__PURE__*/React.createElement("a", {
        className: "button disabled",
        href: "#",
        title: "Next"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_rigth.svg"
      })), this.state.CurrentPage < Math.ceil(this.state.DataCount / this.props.pageSize) && /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.nextPage.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Next"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_rigth.svg"
      }))))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 select-wrap-middle"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "col-12 list-group list-group-flush"
      }, this.state.OrganizationList.map(function (x, _i) {
        return /*#__PURE__*/React.createElement("li", {
          className: "list-group-item",
          key: x.OrganizationId
        }, /*#__PURE__*/React.createElement("div", {
          className: "row"
        }, _this9.state.CurrentUserAuthorityId == 1 && [/*#__PURE__*/React.createElement("div", {
          className: "col-1 cursorpointer",
          onClick: _this9.openModifyOrganizationModal.bind(_this9, x)
        }, x.OrganizationId), /*#__PURE__*/React.createElement("div", {
          className: "col-2 cursorpointer",
          onClick: _this9.openModifyOrganizationModal.bind(_this9, x)
        }, x.OrganizationName), /*#__PURE__*/React.createElement("div", {
          className: "col-2 cursorpointer",
          onClick: _this9.openModifyOrganizationModal.bind(_this9, x)
        }, x.ActualServiceType == null ? null : _this9.getServiceTypeDisplayName(x.ActualServiceType)), /*#__PURE__*/React.createElement("div", {
          className: "col-1 cursorpointer",
          onClick: _this9.openModifyOrganizationModal.bind(_this9, x)
        }, _this9.getOrganizationStatusDisplayName(x.OrganizationStatus)), /*#__PURE__*/React.createElement("div", {
          className: "col-3 cursorpointer row",
          onClick: _this9.openModifyOrganizationModal.bind(_this9, x)
        }, OrganizationStatusTypes.ScheduleContract == x.OrganizationStatus && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: "date"
        }, moment(x.NearFutureContractFromDate).format("YYYY/M")), /*#__PURE__*/React.createElement("div", {
          className: "date-delimiter"
        }, "-"), /*#__PURE__*/React.createElement("div", {
          className: "date"
        }, moment(x.NearFutureContractToDate).format("YYYY/M"))), x.ActualContractFromDate != null && [OrganizationStatusTypes.UnderContract, OrganizationStatusTypes.Deleted, OrganizationStatusTypes.Suspended, OrganizationStatusTypes.Trial].some(function (n) {
          return n == x.OrganizationStatus;
        }) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: "date"
        }, moment(x.ActualContractFromDate).format("YYYY/M")), /*#__PURE__*/React.createElement("div", {
          className: "date-delimiter"
        }, "-"), /*#__PURE__*/React.createElement("div", {
          className: "date"
        }, moment(x.ActualContractToDate).format("YYYY/M")))), /*#__PURE__*/React.createElement("div", {
          className: "col-1 cursorpointer",
          onClick: _this9.openModifyOrganizationModal.bind(_this9, x)
        }, x.UseEverywhere == null ? null : _this9.getUseEverywhereDisplayName(x.UseEverywhere)), /*#__PURE__*/React.createElement("div", {
          className: "col-1 cursorpointer",
          onClick: _this9.openModifyOrganizationModal.bind(_this9, x)
        }, x.ActualExtentionFlg == 1 ? intl.format(Label.Support) : ""), /*#__PURE__*/React.createElement("div", {
          className: "col-1 text-right "
        }, x.Deleted == 0 && /*#__PURE__*/React.createElement("a", {
          className: "button",
          onClick: _this9.changeOrganization.bind(_this9, x)
        }, /*#__PURE__*/React.createElement("img", {
          className: "pageIcon",
          width: "24",
          height: "24",
          src: "/assets/img/login.svg"
        })))], _this9.state.CurrentUserAuthorityId != 1 && [/*#__PURE__*/React.createElement("div", {
          className: "col-4 cursorpointer",
          onClick: _this9.openModifyOrganizationModal.bind(_this9, x)
        }, x.OrganizationName), /*#__PURE__*/React.createElement("div", {
          className: "col-3 cursorpointer",
          onClick: _this9.openModifyOrganizationModal.bind(_this9, x)
        }, _this9.getOrganizationStatusDisplayName(x.OrganizationStatus)), /*#__PURE__*/React.createElement("div", {
          className: "col-3 cursorpointer row",
          onClick: _this9.openModifyOrganizationModal.bind(_this9, x)
        }, OrganizationStatusTypes.ScheduleContract == x.OrganizationStatus && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: "date"
        }, moment(x.NearFutureContractFromDate).format("YYYY/M")), /*#__PURE__*/React.createElement("div", {
          className: "date-delimiter"
        }, "-"), /*#__PURE__*/React.createElement("div", {
          className: "date"
        }, moment(x.NearFutureContractToDate).format("YYYY/M"))), x.ActualContractFromDate != null && [OrganizationStatusTypes.UnderContract, OrganizationStatusTypes.Deleted, OrganizationStatusTypes.Suspended, OrganizationStatusTypes.Trial].some(function (n) {
          return n == x.OrganizationStatus;
        }) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: "date"
        }, moment(x.ActualContractFromDate).format("YYYY/M")), /*#__PURE__*/React.createElement("div", {
          className: "date-delimiter"
        }, "-"), /*#__PURE__*/React.createElement("div", {
          className: "date"
        }, moment(x.ActualContractToDate).format("YYYY/M")))), /*#__PURE__*/React.createElement("div", {
          className: "col-1 cursorpointer",
          onClick: _this9.openModifyOrganizationModal.bind(_this9, x)
        }, x.ActualExtentionFlg == 1 ? intl.format(Label.Support) : ""), /*#__PURE__*/React.createElement("div", {
          className: "col-1 text-right "
        }, x.Deleted == 0 && /*#__PURE__*/React.createElement("a", {
          className: "button",
          onClick: _this9.changeOrganization.bind(_this9, x)
        }, /*#__PURE__*/React.createElement("img", {
          className: "pageIcon",
          width: "24",
          height: "24",
          src: "/assets/img/login.svg"
        })))]));
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 select-wrap-bottom"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-1 offset-10 text-right"
      }, this.state.CurrentUserAuthorityId == 1 && /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.openAddOrganizationModal.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Add organization"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "36",
        height: "36",
        src: "/assets/img/add_icon.svg"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-1 text-right paging-btn"
      }, this.state.CurrentPage <= 1 && /*#__PURE__*/React.createElement("a", {
        className: "button disabled",
        href: "#",
        title: "Previous"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_left.svg"
      })), this.state.CurrentPage > 1 && /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.previousPage.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Previous"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_left.svg"
      })), this.state.CurrentPage >= Math.ceil(this.state.DataCount / this.props.pageSize) && /*#__PURE__*/React.createElement("a", {
        className: "button disabled",
        href: "#",
        title: "Next"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_rigth.svg"
      })), this.state.CurrentPage < Math.ceil(this.state.DataCount / this.props.pageSize) && /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.nextPage.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Next"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_rigth.svg"
      }))))))), this.state.OrganizationModalMode != OrganizationModalComponent.Mode.None && /*#__PURE__*/React.createElement(OrganizationModalComponent["default"], {
        mode: this.state.OrganizationModalMode,
        organizationId: NullNumberToBlank(this.state.Selected ? this.state.Selected.OrganizationId : null),
        organizationName: this.state.Selected ? this.state.Selected.OrganizationName : "",
        domain: this.state.Selected ? this.state.Selected.Domain : "",
        useEverywhere: this.state.Selected ? this.state.Selected.UseEverywhere : false,
        useOneDrive: this.state.Selected ? this.state.Selected.UseOneDrive : false,
        clientId: this.state.Selected ? this.state.Selected.ClientId : "",
        contractList: this.state.Selected ? this.state.Selected.ContractList : [],
        deleted: this.state.Selected ? this.state.Selected.Deleted.toString() : "0",
        updateDateTime: this.state.Selected ? this.state.Selected.UpdateDateTime : "",
        maxNumberOfUsersPerOrganization: this.props.maxNumberOfUsersPerOrganization,
        maxNumberOfGuestsPerOrganization: this.props.maxNumberOfGuestsPerOrganization,
        maxNumberOfUsersPerOrganizationForStarterEdition: this.props.maxNumberOfUsersPerOrganizationForStarterEdition,
        maxNumberOfGuestsPerOrganizationForStarterEdition: this.props.maxNumberOfGuestsPerOrganizationForStarterEdition,
        onEntry: this.entryOrganizationModal.bind(this),
        onModify: this.modifyOrganizationModal.bind(this),
        onDelete: this.deleteOrganizationModal.bind(this),
        onChangeStatus: this.changeServiceStatus.bind(this),
        onHidden: this.hiddenOrganizationModal.bind(this)
      }), this.state.OrganizationSupportModalMode != OrganizationSupportModalComponent.Mode.None && /*#__PURE__*/React.createElement(OrganizationSupportModalComponent["default"], {
        mode: this.state.OrganizationSupportModalMode,
        organizationId: NullNumberToBlank(this.state.Selected ? this.state.Selected.OrganizationId : null),
        organizationName: this.state.Selected ? this.state.Selected.OrganizationName : "",
        extentionFlg: this.state.Selected ? this.state.Selected.ActualExtentionFlg.toString() : "0",
        updateDateTime: this.state.Selected ? this.state.Selected.UpdateDateTime : "",
        organizationStatus: this.state.Selected ? this.state.Selected.OrganizationStatus : OrganizationStatusTypes.Deleted,
        onChangeActualExtentionFlg: this.changeActualExtentionFlg.bind(this),
        onHidden: this.hiddenOrganizationSupportModal.bind(this)
      }));
    }
  }]);

  return MainComponent;
}(React.Component);
/**
 * レンダラー
 *
 * @param el バインド対象
 * @param common 共通
 */


export default function (el, common, pageSize, maxNumberOfUsersPerOrganization, maxNumberOfGuestsPerOrganization, maxNumberOfUsersPerOrganizationForStarterEdition, maxNumberOfGuestsPerOrganizationForStarterEdition) {
  ReactDOM.render( /*#__PURE__*/React.createElement(MainComponent, {
    common: common,
    pageSize: pageSize,
    maxNumberOfUsersPerOrganization: maxNumberOfUsersPerOrganization,
    maxNumberOfGuestsPerOrganization: maxNumberOfGuestsPerOrganization,
    maxNumberOfUsersPerOrganizationForStarterEdition: maxNumberOfUsersPerOrganizationForStarterEdition,
    maxNumberOfGuestsPerOrganizationForStarterEdition: maxNumberOfGuestsPerOrganizationForStarterEdition
  }), el);
}